import clsx from 'clsx';
import * as React from 'react';

import { ifTrue } from 'src/tools/logic.tools';

import { AnyValue, ButtonBaseType, ID } from 'src/models/general.model';
import { FormParserContext } from 'src/contexts/form.context';

import { P2 } from 'src/components/Typography';

import classes from './TextSwitch.module.scss';

export function TextSwitch() {
  const { script, value, onChange } = React.useContext(FormParserContext);

  if (!script.items) return <></>;

  function getValueToUse(val: AnyValue) {
    if (script.type === 'boolean' && script.placeholder) {
      const item = script.items?.find(i => val === (i.id === script.placeholder)) || script.items?.[0];

      return item?.id;
    }

    return val;
  }

  const valueToUse = getValueToUse(value ?? script.defaultValue ?? script.items[0].id);

  const valueIsEqualItemZero = valueToUse === script.items[0].id;

  function handleClick(id: ID) {
    return function call() {
      if (script.type === 'boolean' && script.placeholder) onChange(id === script.placeholder);
      else onChange(id);
    };
  }

  function renderButton(item: ButtonBaseType, className: string) {
    return (
      <button className={className} onClick={handleClick(item.id)}>
        <P2>{item.label}</P2>
      </button>
    );
  }

  return (
    <div>
      <div className={clsx('row a-center j-between', classes.container)}>
        {renderButton(script.items[0], ifTrue(valueIsEqualItemZero, classes['selected-button'], classes.button))}
        {renderButton(script.items[1], ifTrue(valueIsEqualItemZero, classes.button, classes['selected-button']))}
      </div>
    </div>
  );
}
